export const NavPath = [
  // {
  //   to: '/notifications',
  //   itemTitle: "Notif",
  //   does: 'get_collaborater_notifications',
  // },
  {
    to: '/home',
    itemTitle: "Fil d'actualité",
    does: ['get_authenticated_collaborator'],
  },
  {
    to: ['/collaboraters', '/collaboraters/interviews'],
    itemTitle: ['Collaborateurs', 'Entretiens'],
    does: ['get_collaboraters', 'get_all_collaboraters_interviews'],
    dropDown: [
      {
        to: '/collaboraters/interviews',
        itemTitle: 'Entretiens',
        does: ['get_all_collaboraters_interviews'],
      },
    ],
  },
  {
    itemTitle: 'Demandes',
    to: ['/requests/all-requests', '/requests/my-requests', '/requests/my-team-requests'],
    does: ['get_demands', 'get_collaborater_demands', 'get_collaborater_team_demands'],
    dropDown: [
      {
        to: '/requests/all-requests',
        itemTitle: 'Toutes les demandes',
        does: ['get_demands'],
      },
      {
        to: '/requests/my-requests',
        itemTitle: 'Mes demandes',
        does: ['get_collaborater_demands'],
      },
      {
        to: '/requests/my-team-requests',
        itemTitle: 'Les demandes de mon équipe',
        does: ['get_collaborater_team_demands'],
      },
    ],
  },
  {
    to: '/contracts',
    itemTitle: 'Contrats',
    does: ['get_contracts'],
  },
  {
    to: '/galerie',
    itemTitle: 'Galerie',
    does: ['get_albums_gallery'],
  },
  {
    to: '/activities',
    itemTitle: 'Activites',
    does: ['get_activities_list'],
  },
  {
    to: ['/hardwares'],
    itemTitle: ['Ressources Informatiques', 'Matériels', 'Lociciels'],
    does: ['get_hardwares', 'get_hardwares', 'get_hardwares'],
    dropDown: [
      {
        to: '/hardwares',
        itemTitle: 'Matériels',
        does: ['get_hardwares'],
      },
      {
        to: '/softwares',
        itemTitle: 'Logiciels',
        does: ['get_hardwares'],
      },
    ],
  },
  // {
  //   to: '/hardwares',
  //   itemTitle: 'Matériels',
  //   does: ['get_hardwares'],
  // },
  {
    to: '/missions',
    itemTitle: 'Missions',
    does: ['get_missions'],
  },
  {
    to: '/transactions',
    itemTitle: 'Notes de frais',
    does: ['get_collaborators_balances'],
  },
  {
    itemTitle: 'Recrutement',
    to: [
      '/recruitment/candidates/applications',
      '/recruitment/my-candidates/applications',
      '/recruitment/my-candidates/applications',
      '/recruitment/newsletter',
      '/recruitment/recruitment-requests',
    ],
    does: [
      'get_candidates',
      'get_candidates_grouped_by_mobile_number',
      'get_authenticated_collaborater_candidates',
      'get_newsletter_subscribers',
      'get_recruitment_requests_list',
    ],
    dropDown: [
      {
        to: '/recruitment/candidates/applications',
        itemTitle: 'Candidatures',
        does: ['get_candidates'],
      },
      {
        to: '/recruitment/candidates',
        itemTitle: 'Candidats',
        does: ['get_candidates_grouped_by_mobile_number'],
      },
      {
        to: '/recruitment/my-candidates/applications',
        itemTitle: 'Mes candidatures',
        does: ['get_authenticated_collaborater_candidates'],
      },
      {
        to: '/recruitment/newsletter',
        itemTitle: 'Newsletter',
        does: ['get_newsletter_subscribers'],
      },
      {
        to: '/recruitment/recruitment-requests',
        itemTitle: 'Expression de besoin',
        does: ['get_recruitment_requests_list'],
      },
    ],
  },
  {
    to: ['/time-registrations/all-collaboraters', '/time-registrations/all', '/time-registrations/daily-gaps'],
    does: [
      'get_all_collaborators_last_time_registrations',
      'get_all_time_registrations',
      'get_all_daily_working_time_gaps',
    ],
    itemTitle: 'Pointage',
    dropDown: [
      {
        to: '/time-registrations/all-collaboraters',
        itemTitle: 'Collaborateur par statut',
        does: ['get_all_collaborators_last_time_registrations'],
      },
      {
        to: '/time-registrations/all',
        itemTitle: 'Liste des pointages',
        does: ['get_all_time_registrations'],
      },
      {
        to: '/time-registrations/daily-gaps',
        itemTitle: 'Écart par jour',
        does: ['get_all_daily_working_time_gaps'],
      },
    ],
  },
  {
    to: [
      '/absences-leaves/all-leaves',
      '/absences-leaves/my-leaves',
      '/absences-leaves/all-leave-requests',
      '/absences-leaves/my-leave-requests',
      '/absences-leaves/team-leave-requests',
      '/absences-leaves/all-absences',
      '/absences-leaves/my-absences',
    ],
    does: [
      'get_list_of_all_leaves',
      'get_authenticated_collaborater_leaves',
      'get_list_of_all_leave_requests',
      'get_authenticated_collaborater_leave_requests',
      'get_collaborater_team_leave_requests',
      'get_authenticated_collaborater_absences',
    ],
    itemTitle: 'Congés et absences',
    dropDown: [
      {
        to: '/absences-leaves/all-leaves',
        itemTitle: 'Congés',
        does: ['get_list_of_all_leaves'],
      },
      {
        to: '/absences-leaves/my-leaves',
        itemTitle: 'Mes congés',
        does: ['get_authenticated_collaborater_leaves'],
      },
      {
        to: '/absences-leaves/all-leave-requests',
        itemTitle: 'Toutes les demandes de congés',
        does: ['get_list_of_all_leave_requests'],
      },
      {
        to: '/absences-leaves/my-leave-requests',
        itemTitle: 'Mes demandes de congés',
        does: ['get_authenticated_collaborater_leave_requests'],
      },
      {
        to: '/absences-leaves/team-leave-requests',
        itemTitle: 'Demandes de congés de mon équipe',
        does: ['get_collaborater_team_leave_requests'],
      },
      {
        to: '/absences-leaves/all-absences',
        itemTitle: 'Toutes les absences',
        does: ['get_absences'],
      },
      {
        to: '/absences-leaves/my-absences',
        itemTitle: 'Mes absences',
        does: ['get_authenticated_collaborater_absences'],
      },
    ],
  },
  {
    to: ['/events', '/events', '/events/statistics', '/events/statistics', '/events/statistics'],
    itemTitle: ['Calendrier', 'Calendrier', 'Rapports du planning', 'Rapports du planning', 'Rapports du planning'],
    does: [
      'get_list_of_all_events_paginated_and_filtered',
      'get_list_of_all_events_calendar',
      'get_events_reports_by_status',
      'get_events_reports_by_collaborators',
      'get_events_reports_by_types',
    ],
    dropDown: [
      {
        to: '/events/statistics',
        itemTitle: 'Rapports du planning',
        does: ['get_events_reports_by_status', 'get_events_reports_by_collaborators', 'get_events_reports_by_types'],
        onOfDoes: true,
      },
    ],
  },
  {
    to: [
      '/settings/jobs',
      '/settings/departments',
      '/settings/entities',
      '/settings/demands/subjects',
      '/settings/contracts/article_models',
      '/settings/contracts/contract_models',
      '/settings/skills',
      '/settings/hardwares/types',
      '/settings/software/types',
      '/settings/locations',
      '/settings/company/params',
      '/settings/acl/roles',
      '/settings/acl/actions',
      '/settings/time-registration/holidays',
      '/settings/time-registration/default-timetable',
      '/settings/transactions/expenses',
      '/settings/transactions/recharges',
      '/settings/transactions/kilometers-coefficient',
      '/settings/leaves/special-leaves-types',
      '/settings/leaves/annual-leaves-params',
      '/settings/emails-models',
      '/settings/planning/teams',
      '/settings/planning/events',
      '/settings/tasks-models',
    ],
    itemTitle: 'Paramètres',
    does: [
      'get_jobs',
      'get_departments',
      'get_entities_list',
      'get_subjects',
      'get_article_models',
      'get_contract_models',
      'get_skills',
      'get_hardwares_types',
      'get_software_types',
      'get_hardware_assignment_locations_list',
      'get_company_parameters',
      'get_all_roles',
      'get_actions',
      'get_holidays',
      'get_default_weekly_time_table',
      'get_expenses_types',
      'get_recharges_types',
      'get_kilometer_coefficient',
      'get_special_leaves_types',
      'get_annual_leaves_params',
      'get_job_offer_email_model',
      'get_teams',
      'get_events_types',
      'get_checklist_models_list',
    ],
  },
  {
    to: '/csv-modifier',
    itemTitle: 'Modificateur CSV',
    does: ['csv_editor'],
  },
];
